import React, { useState } from 'react'
import { useTransition } from 'react-spring'


import { Skeleton } from 'components/skeleton'
import {
    PendingDemandButton,
    DemandWrap,
    DemandIcon,
    TextContainer,
} from './pendingBuysButton.styles'


interface PendingBuysProps {
    checkPendingBuys: number[]
    isLoading?: boolean
}

export const PendingBuysButton = ({ checkPendingBuys, isLoading }: PendingBuysProps): React.ReactElement => {

    //const INFO_WIDTH = 200

    const [showText, setShowText] = useState(false);

    let text: string
    let amount = 0
    if (checkPendingBuys[1] > 0) amount = checkPendingBuys[0]
    if (amount > 0) {
        text = "- Orders: " + Number(checkPendingBuys[1]).toString() + '\n- USDC: ' + Number(checkPendingBuys[0]/1000000).toString()
    }
    const transitions = useTransition(showText, {
        config: { duration: 150 },
        from: { opacity: 0, transform: 'scaleY(0.95)' },
        enter: { opacity: 1, transform: 'scaleY(1)' },
        leave: { opacity: 0, transform: 'scaleY(0.95)' },
    })

    return (
        < DemandWrap >
            <PendingDemandButton disabled={0 >= Number(checkPendingBuys[1])} onClick={(e) => { e.preventDefault() }}
                onMouseEnter={() => { setShowText(true) }}
                onMouseLeave={() => setShowText(false)} >

                <DemandIcon icon="work_history" />               
                {isLoading ? (
                    <Skeleton />
                ) : (
                    Number(checkPendingBuys[1])
                )}
                {transitions(
                    (styles, showText) =>
                        showText && text && (
                            <TextContainer style={styles} >
                                    {text.split('\n').map((line, idx) => <p key={idx}>{line}</p>)}
                            </TextContainer>
                        )
                )}
            </PendingDemandButton>
        </DemandWrap >

    )
}